var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { BackgroundModel } from '../engine/models/background.model';
import { ColorUtils } from '../shared/libraries/colors/colors';
var depreactedUIConfigNames = [
    'ui-bd.class',
    'ui-play-pause',
    'ui-camera-mode',
    'ui-center',
    'ui-cross-section',
    'ui-dissect',
    'ui-fs',
    'ui-tools-display',
    'ui-tree',
    'ui-zoom',
    'ui-zoom-in',
    'ui-zoom-out',
    'ui-pan',
    'ui-share',
    'ui-keys',
    'ui-slider'
];
var depreactedNonUIConfigNames = [
    'o',
    'background.color-stops',
    'background.gradient-type',
    'dd',
    'dn',
    'image-display',
    'imageDisplay',
    'imageSrc',
    'pre',
    'referrer'
];
export var deprecatedConfigNames = __spread(depreactedUIConfigNames, depreactedNonUIConfigNames);
// normalizes legacy id params (s, m, be, b) into standard id
export function normalizeQueryIdParam(config) {
    var id = config.id, s = config.s, m = config.m, be = config.be, b = config.b;
    var contentId = '';
    if (id) { // pass-through id
        contentId = id;
    }
    else if (be) { // encoded bookmark id
        contentId = be;
    }
    else if (b) { // decoded bookmark id
        var bookmarkId = parseInt(b, 10);
        contentId = Number.isNaN(bookmarkId) ? '' : encodeBookmarkId(bookmarkId);
    }
    else if (m) { // module id
        var sex = s === 'female' ? 'female' : 'male';
        contentId = normalizeModuleId(m, sex);
    }
    // trim trailing .json 
    return contentId.replace(/\.json$/, '');
}
export function normalizeQueryTypeParam(config) {
    // determine type by id
    var contentId = normalizeQueryIdParam(config);
    return contentId.includes('/') ? 'module' : 'bookmark';
}
// ported from: https://github.com/biodigital-human/human-cms/blob/f8608ac6c523318b4a21ac76b200dbd3928abc1f/content/bookmarks.py#L46
function encodeBookmarkId(bookmarkId) {
    var _a;
    var BASE62_IDX = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    var divmod = function (x, y) {
        var quotient = Math.floor(x / y);
        var remainder = x % y;
        return [quotient, remainder];
    };
    var encoded = [];
    var num = bookmarkId;
    var digit;
    while (num > 0) {
        _a = __read(divmod(num, 62), 2), num = _a[0], digit = _a[1];
        encoded.unshift(BASE62_IDX[digit]);
    }
    return encoded.join('');
}
function normalizeModuleId(id, sex) {
    if (sex === void 0) { sex = 'male'; }
    return id.includes('/')
        ? id // use full module name
        : "production/" + sex + "Adult/" + id; // normalize short module names    
}
var ɵ0 = function (params) { return normalizeQueryTypeParam(params); }, ɵ1 = function (p) { return normalizeQueryIdParam(p); }, ɵ2 = function (p) { return p['bgstd'] || p['background.colors'] || p['background']; };
// normalize into single params
var paramTransforms = {
    'type': ɵ0,
    'id': ɵ1,
    // background normalization
    'background': ɵ2
};
function dropDeprecatedParams(config) {
    var configKeys = Object.keys(config);
    var deprecatedKeys = configKeys
        .filter(function (key) { return deprecatedConfigNames.includes(key); });
    // warning: deprecated params
    if (deprecatedKeys.length > 0) {
        var messages = [
            "The following URL parameters have been deprecated: \"" + deprecatedKeys.join('", "') + "\"",
            "Please contact support@biodigital.com for more information."
        ];
        console.warn(messages.join('\n'));
    }
    return configKeys.reduce(function (acc, key) {
        // drop if deprecated
        if (deprecatedConfigNames.includes(key)) {
            delete acc[key];
        }
        return acc;
    }, config);
}
function transformParams(config) {
    return Object.keys(paramTransforms)
        // exclude already defined params
        .filter(function (targetParamId) { return typeof config[targetParamId] === 'undefined'; })
        // transform many -> one params
        .reduce(function (acc, targetParamId) {
        var transform = paramTransforms[targetParamId];
        var transformedValue = transform(config);
        if (typeof (transformedValue) !== 'undefined') {
            acc[targetParamId] = transformedValue;
        }
        return acc;
    }, config);
}
function toXYZ(values) {
    if (values.length === 3) {
        var x = values[0], y = values[1], z = values[2];
        return { x: x, y: y, z: z };
    }
    else {
        return null;
    }
}
function parseCamera(input) {
    // comma seperated camera values -> number[]
    var values = input
        .split(',')
        .map(function (entry) { return parseFloat(entry); });
    // validate required 3 part camera values (eye required) + valid numbers
    var valid = values.length % 3 === 0 && !values.some(function (value) { return Number.isNaN(value); });
    if (valid) {
        // required: eye
        var eyeValues = values.slice(0, 3);
        // optional additions
        var lookValues = values.slice(3, 6);
        var upValues = values.slice(6, 9);
        return {
            eye: toXYZ(eyeValues),
            look: toXYZ(lookValues),
            up: toXYZ(upValues)
        };
    }
    else {
        return null;
    }
}
function parseBackground(input) {
    // parse color
    var colorValues = ColorUtils.getColors(input);
    if (colorValues) {
        // get colors (first + second) as 255
        var color1 = colorValues[0]['255'];
        var color2 = colorValues[1]['255'];
        // create background model
        var colors = __spread(color1, color2);
        var gradientType = 'radial';
        var colorStops = [0, 100];
        return new BackgroundModel(colors, gradientType, colorStops);
    }
    else {
        return null;
    }
}
var paramValueTransform = {
    'camera': parseCamera,
    'background': parseBackground
};
// coerce strings to booleans where appropriate
function coerceValues(config) {
    var coerceValue = function (value) {
        if (value) {
            var normalizedValue = value.toLowerCase();
            if (normalizedValue === 'true') {
                return true;
            }
            else if (normalizedValue === 'false') {
                return false;
            }
            else if (!isNaN(Number(normalizedValue))) {
                return Number(normalizedValue);
            }
        }
        return value;
    };
    return Object.keys(config).reduce(function (acc, key) {
        // get custom value transformer else default
        var valueTransformer = paramValueTransform[key] || coerceValue;
        var value = valueTransformer(config[key]);
        // patch for JnJ
        // sanitize load rotate
        // Later: define coercion for each property instead of making assumptions.
        if (key === 'load-rotate' && isNaN(Number(value))) {
            return acc;
        }
        acc[key] = value;
        return acc;
    }, {});
}
export function getInitialWidgetConfig(rawParams) {
    var withoutDeprecated = dropDeprecatedParams(rawParams);
    var transformedConfig = transformParams(withoutDeprecated);
    var coercedConfig = coerceValues(transformedConfig);
    return coercedConfig;
}
export { ɵ0, ɵ1, ɵ2 };
